import { useState, useEffect } from 'react';
import { AppConfigContext } from '../context';
import { useContext } from 'react';

export const useTokenPrice = (token: string) => {
    const { apiUrl } = useContext(AppConfigContext);
    const [price, setPrice] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchPrice = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `${apiUrl}/kyros/price?token=${token}`
            );
            const data = await response.json();
            if (data) {
                setPrice(data.price);
            } else {
                throw new Error(`${token} price data not found`);
            }
        } catch (err) {
            console.error(`Error fetching ${token} price:`, err);
            setError(`Error fetching ${token} Price`);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPrice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { price, isLoading, error };
};
